import React, {CSSProperties, PropsWithChildren, ReactNode} from 'react';
import classnames from 'classnames';
import CLMandatoryFieldMarker from '../CLMandatoryFieldMarker/CLMandatoryFieldMarker';
import CLInfo from '../CLInfo/CLInfo';

import styles from './CLLabel.module.scss';

export enum CLLabelType {
  Success,
  Warning,
  Error,
}

export interface CLLabelProps {
  className?: string;
  withMandatoryMark?: boolean;
  style?: CSSProperties;
  help?: ReactNode;
  labelType?: CLLabelType;
  onClick?: (event: React.MouseEvent) => void;
}

function CLLabel({
  children,
  className = '',
  style,
  withMandatoryMark = false,
  help,
  labelType,
  onClick = () => {},
}: PropsWithChildren<CLLabelProps>) {
  return (
    <div
      onClick={onClick}
      className={classnames(styles.cl_common_label, className, {
        [styles.warning]: labelType === CLLabelType.Warning,
        [styles.error]: labelType === CLLabelType.Error,
        [styles.success]: labelType === CLLabelType.Success,
      })}
      style={style}
    >
      {children} {withMandatoryMark && <CLMandatoryFieldMarker />}{' '}
      {help && <CLInfo theme={{iconClassName: styles.info_icon}} innerInfoContent={help} />}
    </div>
  );
}

export default CLLabel;
